export default __webpack_public_path__ + "assets/logo_bengt-92583c2a.png";